/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-category': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.875 13.838V11.25c0-.69-.56-1.25-1.25-1.25h-5V7.5h1.25c.69 0 1.25-.56 1.25-1.25V2.5c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25h1.25V10h-5c-.69 0-1.25.56-1.25 1.25v2.589a2.5 2.5 0 101.25 0V11.25h5v2.589a2.5 2.5 0 101.25 0V11.25h5v2.588a2.5 2.5 0 101.25 0zM8.125 2.5h3.75v3.75h-3.75V2.5zM5 16.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm6.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm5 1.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"/>'
  }
})
